import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useGlobalState } from 'src/sites/state'

const alignmentOptions = {
   left: {
      justifyContent: 'flex-start',
      textAlign: 'left'
   },
   center: {
      justifyContent: 'center',
      textAlign: 'center'
   },
   right: {
      justifyContent: 'flex-end',
      textAlign: 'right'
   }
}

// Component to show when there is no data to show
const EmptyContentBlock = ({ align, height, message, textColor }) => {
   const { theme } = useGlobalState()

   return (
      <View
         display="flex"
         width="100%"
         height={height}
         justifyContent={alignmentOptions[align].justifyContent}
         alignItems="center"
         paddingHorizontal="30px"
         textAlign={alignmentOptions[align].textAlign}>
         <Text
            size={theme.tmpSubBodyTextSize}
            color={textColor || theme.tmpContentTextColor}
            style={{ opacity: 0.5 }}>
            {message}
         </Text>
      </View>
   )
}

EmptyContentBlock.propTypes = {
   align: PropTypes.oneOf(['left', 'center', 'right']),
   height: PropTypes.string,
   message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
   textColor: PropTypes.string
}

EmptyContentBlock.defaultProps = {
   align: 'center',
   height: '60px',
   textColor: undefined
}

export default EmptyContentBlock
